import { action, observable, runInAction } from "mobx"

import { postBadgeRequest } from "~/api/badges/post"
import { fetchBadgeOperation } from "~/api/badges/post"
import { Badge, TBadgeLevel } from "~/entities/Badge"
import { BadgeCategory } from "~/entities/BadgeCategory"

import { fetchListBadge } from "../api/badges/get"

type TOverall = {
  count_awaiting: number
  count_registered: number
}
export default class BadgeStore {
  @observable categories: BadgeCategory[] = []
  @observable overall: TOverall = {
    count_awaiting: 0,
    count_registered: 0,
  }

  fetch = async () => {
    const response = await fetchListBadge("all")
    runInAction(() => {
      if (response.error == null) {
        this.categories =
          response.categories?.map((category) => {
            return new BadgeCategory({ ...category })
          }) || []
        this.overall = response.overall
      }
    })
    return response
  }

  isBadge = (obj: any): obj is Badge => {
    return obj && typeof obj.badge_name === "string"
  }

  @action
  register = async (badgeId: number, level: TBadgeLevel) => {
    await fetchBadgeOperation({ badgeId: badgeId, level: level, action: "register" })
    // update statuses of badge again
    await this.fetch()
  }

  @action
  removeRegistration = async (badgeId: number, level: TBadgeLevel) => {
    await fetchBadgeOperation({
      action: "remove",
      badgeId: badgeId,
      level: level,
    })
    // update statuses of badge again
    await this.fetch()
  }

  @action
  deleteRegistration = async (badgeId: number, level: TBadgeLevel) => {
    await fetchBadgeOperation({
      action: "delete",
      badgeId: badgeId,
      level: level,
    })
    // update statuses of badge again
    await this.fetch()
  }
}
